export default __webpack_public_path__ + "pdf/Martin_Krzywinski.573f840.pdf";